__turbopack_context__.v({
  "captionLabel": "_0uFaqq_captionLabel",
  "navButton": "_0uFaqq_navButton",
  "surface": "_0uFaqq_surface",
  "weekday": "_0uFaqq_weekday",
});
